import React from 'react';
import { BaseAnswer, SurveyQuestionOption } from '@x-guard/xgac-types/xgac';
import styles from './style.module.scss';
import Button from '../Button';

interface MultipleChoiceProps {
  options: SurveyQuestionOption[];
  onClick: (option: BaseAnswer) => void;
}

const MultipleChoice: React.FC<MultipleChoiceProps> = ({ options, onClick }) => {

  return (
    <div className={styles['multiple-choice']}>
      <div className={styles['button-wrapper']}>
        {options.map((option, index) => {

          return (
            <div key={index} className={styles.option}>
              <Button text={option.label} color={option.variant} onClick={() => onClick({ value: option.value, label: option.label })}/>
            </div>
          );

        })}
      </div>
    </div>
  );

};

export default MultipleChoice;
